export default __webpack_public_path__ + "static/footer-brown-bg-0d11f24320cd0179935cf2c5f32c0ecf.png";